import { render, staticRenderFns } from "./ServicerInfo.vue?vue&type=template&id=67eb3778&scoped=true&"
import script from "./ServicerInfo.vue?vue&type=script&lang=js&"
export * from "./ServicerInfo.vue?vue&type=script&lang=js&"
import style0 from "./ServicerInfo.vue?vue&type=style&index=0&id=67eb3778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb3778",
  null
  
)

export default component.exports